import PageContainer from '@/common/components/PageContainer'
import { useQueryStates, parseAsInteger, parseAsString } from 'nuqs'
import useQueryGetTurnoverEvents from '@/modules/events/api/hooks/useQueryGetTurnoverEvents'
import EventListing from '@/modules/events/components/EventListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useDebounceValue } from 'usehooks-ts'
import type { UnifiedEventData, TurnoverEventData } from '@/modules/events/type'

function EventsPage() {
	const [queryParams] = useQueryStates({
		page: parseAsInteger.withOptions({ shallow: false }).withDefault(1),
		limit: parseAsInteger.withOptions({ shallow: false }).withDefault(10),
		q: parseAsString.withOptions({ shallow: false }).withDefault(''),
		type: parseAsString.withOptions({ shallow: false }).withDefault('ALL'),
		status: parseAsString.withOptions({ shallow: false }).withDefault('ALL'),
	})

	const [debouncedQuery] = useDebounceValue(queryParams.q, 500)

	const skip = (queryParams.page - 1) * queryParams.limit
	const take = queryParams.limit

	// Fetch turnover events only
	const { data: turnoverEventsData, isLoading } = useQueryGetTurnoverEvents(
		{
			take,
			skip,
			title: debouncedQuery || undefined,
			status:
				queryParams.status === 'ALL' ? undefined : (queryParams.status as any),
		},
		{
			enabled: true,
		},
	)

	const turnoverEvents: UnifiedEventData[] = (
		turnoverEventsData?.data || []
	).map((event: TurnoverEventData) => ({
		...event,
		eventType: 'TURNOVER' as const,
	}))

	const totalEvents = turnoverEventsData?.total || 0

	return (
		<PageContainer>
			<EventListing
				data={turnoverEvents}
				total={totalEvents}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

const GuardedEventsPage = withUserPermission(EventsPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.WEB_SETTING],
})

export default GuardedEventsPage
